<template>
  <v-dialog v-model="show" width="600" @keydown.esc="close" persistent>
    <v-card v-if="item">
      <v-card-title class="headline grey lighten-2 py-1" primary-title>
        <v-row align="center">
          <v-col>
            {{ $t(`healthCheck.decline.title`) }}
          </v-col>
          <v-col cols="auto">
            <v-btn icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <div class="ml-2 mt-3" v-if="item">
          {{ item.healthCheckScheduleStart | date }}
        </div>
        <div class="ml-2">
          {{
            item.healthCheckTimeslotStartTime
              ? new Date(item.healthCheckTimeslotStartTime)
                  .toISOString()
                  .slice(11, 16)
              : ""
          }}
          -
          {{
            item.healthCheckTimeslotEndTime
              ? new Date(item.healthCheckTimeslotEndTime)
                  .toISOString()
                  .slice(11, 16)
              : ""
          }}
        </div>
        <div class="ml-2">
          {{ employee.firstName }}
          {{ employee.lastName }}
        </div>
        <v-row>
          <v-col>
            <v-text-field
              v-model="reason"
              :label="$t(`healthCheck.decline.reason`)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">{{
          $t("dialog.cancel")
        }}</v-btn>
        <v-btn color="primary" text @click="save" :disabled="!reason">{{
          $t("dialog.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DeclineHealthCheckMutation from "@/graphql/mutation/healthCheck/DeclineHealthCheck.gql";
import { combineDateAndTime } from "@/utils/HealthCheckHelper.js";

export default {
  props: {
    employee: {
      type: Object,
    },
    item: {
      type: Object,
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      reason: "",
    };
  },
  methods: {
    close() {
      this.reason = "";
      this.$emit("update:show", false);
    },
    save() {
      const unsuitableDateTime = combineDateAndTime(
        new Date(this.item.healthCheckScheduleStart),
        this.item.healthCheckTimeslotStartTime.slice(11, 16)
      );

      this.$apollo
        .mutate({
          mutation: DeclineHealthCheckMutation,
          variables: {
            healthCheckId: this.item.healthCheckId,
            employeeId: this.employee.id,
            reason: this.reason,
            unsuitableDateTime,
          },
        })
        .then(() => {
          this.$emit("declined");
          this.$emit("update:show", false);
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        });
    },
    combineDateAndTime: combineDateAndTime,
  },
};
</script>

<style></style>
